var _path, _path2, _path3, _path4, _path5, _line;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnBtnExpandImageRightSide = function SvgIcnBtnExpandImageRightSide(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H18C19.1046 0 20 0.895431 20 2V18C20 19.1046 19.1046 20 18 20H0V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1665 8.33366V7.25033C6.1665 6.96301 6.28064 6.68746 6.4838 6.48429C6.68697 6.28113 6.96252 6.16699 7.24984 6.16699H8.33317",
    stroke: "#57595E",
    strokeWidth: 1.27,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1665 12.667V13.7503C6.1665 14.0376 6.28064 14.3132 6.4838 14.5164C6.68697 14.7195 6.96252 14.8337 7.24984 14.8337H8.33317",
    stroke: "#57595E",
    strokeWidth: 1.27,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 6.16699H13.7498C14.0372 6.16699 14.3127 6.28113 14.5159 6.48429C14.719 6.68746 14.8332 6.96301 14.8332 7.25033V8.33366",
    stroke: "#57595E",
    strokeWidth: 1.27,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6665 14.8327H13.7498C14.0372 14.8327 14.3127 14.7185 14.5159 14.5154C14.719 14.3122 14.8332 14.0367 14.8332 13.7493V12.666",
    stroke: "#57595E",
    strokeWidth: 1.27,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: 4.5,
    x2: 0.499999,
    y2: 15.5,
    stroke: "#DDDEE1",
    strokeLinecap: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnBtnExpandImageRightSide, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_btn_expand_image_right_side.3c0b573d.svg";
export { ForwardRef as ReactComponent };